
import React, { Component, Fragment } from 'react';
import { base_url } from '../../globalConstants';
import { Table, Row, Col, Image, Nav, ButtonGroup, Button } from 'react-bootstrap';
import M from "materialize-css";
import { EditOutlined } from "@material-ui/icons";
import Axios from 'axios';
import './addFrancise.css';


export default class FranciseFrag extends Component {
  constructor(props) {
    super(props);
    this.state = ({
      //variables for company detail
      warehouseId: "", 
      warehouseOwnerName: "", 
      warehouseState: "",
      city: "", 
      
      ownerAddressLine1: "",  
      ownerAddressLine2: "",  
      ownerEmailID:"",
      ownerContactNumber:"",
      ownerZip:"",
      ownerLogo:"",
      warehouseOwnerDetails: this.props.warehouse_ownerdata ,      
      warehouseIdList:this.props.warehouseIDList,
      warehouseOwnerIdList:this.props.warehouse_ownerid_list,
      countrylist: this.props.countrylist,       
      countrycodelist: this.props.country_code_list, 
      statedata: this.props.statedata,
      statelist: [], 
      warehouseCountry:"",
      countryId: "", 
      stateSelectOptions: [],
      //end company variables
      error: "",
      editRow: false,
     
      ownerId:"",
      mainId:"",
      url_id:'',
      statelist_origin: [], 
      warehouseCountry_origin:"",
      countryId_origin: "", 
      statelist_destination: [], 
      warehouseCountry_destination:"",
      countryId_destination: "", 
      statelist_broker: [], 
      warehouseCountry_broker:"",
      countryId_broker: "", 
      franchise_id	 :  "",
      company_name	 :  "",
      contact_person	 :  "",
      company_email	 :  "",
      company_contact_no	 :  "",
      company_logo	 :  "logoname",
      company_address_line_1	 :  "",
      company_address_line_2	 :  "",
      company_city	 :  "",
      company_state	 :  "0",
      company_country	 :  "0",
      company_zip	 :  "",
      origin_contact_name	 :  "",
      origin_email_id	 :  "",
      origin_mobile_no	 :  "",
      origin_address_line_1	 :  "",
      origin_address_line_2	 :  "",
      origin_city	 :  "",
      origin_state	 :  "0",
      origin_country	 :  "0",
      origin_zip	 :  "",
      destination_contact_name	 :  "",
      destination_email_id	 :  "",
      destination_mobile_no	 :  "",
      destination_address_line_1	 :  "",
      destination_address_line_2	 :  "",
      destination_city	 :  "",
      destination_state	 :  "0",
      destination_country	 :  "0",
      destination_zip	 :  "",
      shipping_method	 :  "0",
      shipping_priority	 :  "0",
      reverse_shipping	 :  "0",
      email_notification	 :  "0",
      email_use_existing	 :  "0",
      email_client_id	 :  "",
      email_secret	 :  "",
      email_authority	 :  "",
      email_to	 :  "",
      email_bcc	 :  "",
      email_cc	 :  "",
      email_scope	 :  "",
      email_end_point	 :  "",
      email_sendemail_endpoint	 :  "",
      whatsapp_notification	 :  "0",
      whatsapp_existing	 :  "0",
      from_number	 :  "",
      whatsapp_token	 :  "",
      whatsapp_secret	 :  "",
      whatsapp_url	 :  "",
      broker	 :  "0",
      broker_contact_name	 :  "",
      broker_email	 :  "",
      broker_mobile_no	 :  "",
      broker_address_line_1	 :  "",
      broker_address_line_2	 :  "",
      broker_city	 :  "",
      broker_state	 :  "",
      broker_country	 :  "",
      broker_zip	 :  "",
      broker_tax_id	 :  "",
      broker_account_no	 :  "",
      broker_company_name	 :  "",
      active	 :  "1",
      created_by	 :  "1",
      created_on	 :  "",
      modified_by	 :  "1",
      modified_on	 :  "",
      whatsapp_namespace: ""
    })

    console.log("in constructor")
    console.log(this.state.warehouseIdList)
    console.log(this.state.countrylist)
    console.log(this.state.countrycodelist)
    console.log(this.state.statedata)

  }

  handleCountryNameChange = (e) => {

    let selected_countryId = this.state.countrycodelist[this.state.countrylist.indexOf(e.target.value)]
    const states = this.state.statedata[this.state.countrylist.indexOf(e.target.value)].slice()
    this.setState({ warehouseCountry: e.target.value})
    this.setState({ countryId: selected_countryId})
    this.setState({ statelist: states})
  }
  
  handleCountryNameChange_origin = (e) => {

    let selected_countryId = this.state.countrycodelist[this.state.countrylist.indexOf(e.target.value)]
    const states = this.state.statedata[this.state.countrylist.indexOf(e.target.value)].slice()
    this.setState({ warehouseCountry_origin: e.target.value})
    this.setState({ countryId_origin: selected_countryId})
    this.setState({ statelist_origin: states})
  }

  handleCountryNameChange_destination = (e) => {

    let selected_countryId = this.state.countrycodelist[this.state.countrylist.indexOf(e.target.value)]
    const states = this.state.statedata[this.state.countrylist.indexOf(e.target.value)].slice()
    this.setState({ warehouseCountry_destination: e.target.value})
    this.setState({ countryId_destination: selected_countryId})
    this.setState({ statelist_destination: states})
  }

  handleCountryNameChange_broker = (e) => {

    let selected_countryId = this.state.countrycodelist[this.state.countrylist.indexOf(e.target.value)]
    const states = this.state.statedata[this.state.countrylist.indexOf(e.target.value)].slice()
    this.setState({ warehouseCountry_broker: e.target.value})
    this.setState({ countryId_broker: selected_countryId})
    this.setState({ statelist_broker: states})
  }

  handleWarehouseIdChange = async (e) => {
    console.log("WarehouseID selected:- " + e.target.value)
    this.setState({ warehouseId: e.target.value})

  }
  handleCountryIdChange = (e) => {
    console.log("country selected:- " + e.target.value)
    // this.setState({countryname:e.target.value})
    let selected_countryId = this.state.countrycodelist[this.state.countrylist.indexOf(e.target.value)]
    const states = this.state.statedata[this.state.countrylist.indexOf(e.target.value)].slice()

    this.setState({ countryId: selected_countryId, statelist: states })
    // this.setState({statelist:states})
    console.log("state list")
    console.log(this.state.statelist)
  }

  handleStateChange = (e) => {
    console.log("state of ware house", e.target.value)
    this.setState({ company_state: e.target.value })
  }

  handleCityChange = (e) => {
    this.setState({ city: e.target.value })
  }

  handleWarehouseOwnerId = (e) => {
    this.setState({ ownerId: e.target.value })
  }
  handleWarehouseOwnerName = (e) => {
    this.setState({ warehouseOwnerName: e.target.value })
  }
  handleOwnerAddressLine1 = (e) => {
    this.setState({ ownerAddressLine1: e.target.value })
    // this.state.address1.push(this.state.ownerAddressLine1);
  }
  handleOwnerAddressLine2 = (e) => {
    this.setState({ ownerAddressLine2: e.target.value })
  }
  handleOwnerEmailID = (e) => {
    this.setState({ ownerEmailID: e.target.value })
  }

  handleContactNumber = (e) => {
    this.setState({ ownerContactNumber: e.target.value })
  }

  handleFormChange= async (ev) =>{
    const target = ev.target
    const name = target.name
    //console.log(ev.target.name)
    //console.log(ev.target.value)
        this.setState({
          [name]: target.value
        });
   
  }

//EDIT OPTION START
handleEditOption = (e) => {
  this.setState({editRow:true})
  var elems = document.getElementById("addWarehouseOwnerModal");
  var instance = M.Modal.init(elems);
  instance.open()

  let selectedRowIndex ;
              e = e || window.event;
              var data = [];
              var target = e.srcElement || e.target;
              // console.log(target.nodeName)
              while (target && target.nodeName !== "TR") {
                  target = target.parentNode;
                  selectedRowIndex= target.sectionRowIndex
                  console.log("Clicked row",target.sectionRowIndex)
                  // console.log(target.parentNode.index)
              }
              if (target) {
                  var cells = target.getElementsByTagName("td");
                  for (var i = 0; i < cells.length; i++) {
                      data.push(cells[i].innerHTML);
                  }
              }
              let country_name = this.state.countrylist[this.state.countrycodelist.indexOf(data[13])]
              let state_name = this.state.statedata[this.state.countrycodelist.indexOf(data[12])]  
              const states = this.state.statedata[this.state.countrylist.indexOf(country_name)].slice()
              this.setState({ statelist: states})
		      	
              let country_name_origin = this.state.countrylist[this.state.countrycodelist.indexOf(data[13])]
              let state_name_origin = this.state.statedata[this.state.countrycodelist.indexOf(data[12])]  
              const states_origin = this.state.statedata[this.state.countrylist.indexOf(country_name_origin)].slice()
              this.setState({ statelist_origin: states_origin})

              let country_name_destination = this.state.countrylist[this.state.countrycodelist.indexOf(data[13])]
              let state_name_destination = this.state.statedata[this.state.countrycodelist.indexOf(data[12])]  
              const states_destination = this.state.statedata[this.state.countrylist.indexOf(country_name_origin)].slice()
              this.setState({ statelist_destination: states_destination})

              let country_name_broker = this.state.countrylist[this.state.countrycodelist.indexOf(data[13])]
              let state_name_broker = this.state.statedata[this.state.countrycodelist.indexOf(data[12])]  
              const states_broker = this.state.statedata[this.state.countrylist.indexOf(country_name_origin)].slice()
              this.setState({ statelist_broker: states_broker})

              this.setState({mainId: data[1], ownerId: data[1], url_id: data[14]  });
              // let add1 = this.state.address1[data[0]]
              // console.log(add1);
              this.setState({
                  franchise_id: data[3],
                  company_name: data[4],
                  contact_person: data[5],
                  company_email: data[6],
                  company_contact_no: data[7],
                  company_logo: data[8],
                  company_address_line_1: data[9],
                  company_address_line_2: data[10],
                  company_city: data[11], 
                  company_state	 :  data[12],
                  company_country: country_name,
                  countryId: data[13],
      company_zip	 :  data[14],
      shipping_method	 :  data[15],
      shipping_priority	 :  data[16],
      reverse_shipping	 :  data[17],
      email_notification	 :  data[18],
      whatsapp_notification	 :  data[19],
      active	 :  data[20],

      origin_contact_name	 :  data[21],
      origin_email_id	 :  data[22],
      origin_mobile_no	 :  data[23],
      origin_address_line_1	 :  data[24],
      origin_address_line_2	 :  data[25],
      origin_city	 :  data[26],
      origin_state	 :  data[27],
      origin_country	 :  country_name_origin,
      countryId_origin  : data[28],
      origin_zip	 :  data[29],
      
      destination_contact_name	 :  data[30],
      destination_email_id	 :  data[31],
      destination_mobile_no	 :  data[32],
      destination_address_line_1	 :  data[33],
      destination_address_line_2	 :  data[34],
      destination_city	 :  data[35],
      destination_state	 :  data[36],
      destination_country	 :  country_name_destination,
      countryId_destination : data[37],
      destination_zip	 :  data[38],
      
      broker	 :  data[39],
      broker_contact_name	 :  data[40],
      broker_email	 :  data[41],
      broker_mobile_no	 :  data[42],
      broker_address_line_1	 :  data[43],
      broker_address_line_2	 :  data[44],
      broker_city	 :  data[45],
      broker_state	 :  data[46],
      broker_country	 :  country_name_broker,
      countryId_broker : data[47],
      broker_zip	 :  data[48],
      broker_tax_id	 :  data[49],
      broker_account_no	 :  data[50],
      broker_company_name	 :  data[51],

      email_use_existing	 :  data[52],
      email_client_id	 :  data[53],
      email_secret	 :  data[54],
      email_authority	 :  data[55],
      email_to	 :  data[56],
      email_bcc	 :  data[57],
      email_cc	 :  data[58],
      email_scope	 :  data[59],
      email_end_point	 :  data[60],
      email_sendemail_endpoint	 :  data[61],
      
      whatsapp_existing	 :  data[62],
      from_number	 :  data[63],
      whatsapp_token	 :  data[64],
      whatsapp_secret	 :  data[65],
      whatsapp_url	 :  data[66],
      whatsapp_namespace: data[67], 

      created_by	 :  "1",
      created_on	 :  "",
      modified_by	 :  "1",
      modified_on	 :  ""
                                 
                })
              // this.setState({
              //   warehouseId: data[1],
              //   countryId: data[2],
              //   city: data[3],
              //   warehouseOwnerName: data[4],
              //   ownerAddressLine1: "",
              //   ownerAddressLine2: "",
              //   ownerEmailID: data[6],
              //   ownerContactNumber: data[7],
              //   warehouseCountry:country_name,
              // })
              console.log(data[6]);
              // console.log(country_name);
              // console.log(data[5]);

}
openWarehouseOwnerModal =  ()=>{
  this.setState({editRow:false})
  this.setState({
    warehouseId: "", 
    warehouseOwnerName: "", 
    warehouseState: "",
    city: "", 
    countryId: "", 
    ownerAddressLine1: "",  
    ownerAddressLine2: "",  
    ownerEmailID:"",
    ownerContactNumber:"",
    ownerId:"",
    franchise_id	 :  "",
    company_name	 :  "",
    contact_person	 :  "",
    company_email	 :  "",
    company_contact_no	 :  "",
    company_logo	 :  "logoname",
    company_address_line_1	 :  "",
    company_address_line_2	 :  "",
    company_city	 :  "",
    company_state	 :  "0",
    company_country	 :  "0",
    company_zip	 :  "",
    origin_contact_name	 :  "",
    origin_email_id	 :  "",
    origin_mobile_no	 :  "",
    origin_address_line_1	 :  "",
    origin_address_line_2	 :  "",
    origin_city	 :  "",
    origin_state	 :  "0",
    origin_country	 :  "0",
    origin_zip	 :  "",
    destination_contact_name	 :  "",
    destination_email_id	 :  "",
    destination_mobile_no	 :  "",
    destination_address_line_1	 :  "",
    destination_address_line_2	 :  "",
    destination_city	 :  "",
    destination_state	 :  "0",
    destination_country	 :  "0",
    destination_zip	 :  "",
    shipping_method	 :  "0",
    shipping_priority	 :  "0",
    reverse_shipping	 :  "0",
    email_notification	 :  "0",
    email_use_existing	 :  "0",
    email_client_id	 :  "",
    email_secret	 :  "",
    email_authority	 :  "",
    email_to	 :  "",
    email_bcc	 :  "",
    email_cc	 :  "",
    email_scope	 :  "",
    email_end_point	 :  "",
    email_sendemail_endpoint	 :  "",
    whatsapp_notification	 :  "0",
    whatsapp_existing	 :  "0",
    from_number	 :  "",
    whatsapp_token	 :  "",
    whatsapp_secret	 :  "",
    whatsapp_url	 :  "",
    broker	 :  "0",
    broker_contact_name	 :  "",
    broker_email	 :  "",
    broker_mobile_no	 :  "",
    broker_address_line_1	 :  "",
    broker_address_line_2	 :  "",
    broker_city	 :  "",
    broker_state	 :  "",
    broker_country	 :  "",
    broker_zip	 :  "",
    broker_tax_id	 :  "",
    broker_account_no	 :  "",
    broker_company_name	 :  "",
    active	 :  "1",
    created_by	 :  "1",
    created_on	 :  "",
    modified_by	 :  "1",
    modified_on	 :  "",
    whatsapp_namespace: ""
  })
//reset the state for add to warehouseowner
  var elems = document.getElementById("addWarehouseOwnerModal");
  var instance = M.Modal.init(elems);
  instance.open()
        
}
closeModal = ()=>{
  var elems = document.getElementById("addWarehouseOwnerModal");
  var instance = M.Modal.init(elems);
  instance.close();
  this.setState({editRow:false, error:""})
  this.setState({
    warehouseId: "",
    countryId: "",
    city: "",
    warehouseOwnerName: "",
    ownerAddressLine1: "",
    ownerAddressLine2: "",
    ownerEmailID: "",
    ownerContactNumber: "",
    warehouseCountry:"",
    warehouseState:"",
    ownerId:""
  })
}
updateFranciseDetailsDB = async () => {
  if (this.state.company_name.trim().length == 0 ||
  this.state.contact_person.trim().length == 0 ||
  this.state.company_email.trim().length == 0 ||
  this.state.company_contact_no.trim().length == 0 ||
  this.state.company_address_line_1.trim().length == 0 ||
  this.state.company_address_line_2.trim().length == 0 ||
  this.state.company_city.trim().length == 0 ||
  this.state.company_zip.trim().length == 0  )
  {
    alert("All Company Detail fields are mandatory!")
    return;
  }

  let country_code = this.state.countrycodelist[this.state.countrylist.indexOf(this.state.warehouseCountry)]
  let url = base_url+`franchisemaster/${this.state.ownerId}/`


    var warehouseOwnerformdata = new FormData()
        // warehouseOwnerformdata.append("franchise_id", this.state.franchise_id)
    warehouseOwnerformdata.append("company_name", this.state.company_name)
    warehouseOwnerformdata.append("contact_person"	, this.state.contact_person)
    warehouseOwnerformdata.append("company_email"	, this.state.company_email)
    warehouseOwnerformdata.append("company_contact_no"	, this.state.company_contact_no)
    warehouseOwnerformdata.append("company_logo", this.state.company_logo)
    warehouseOwnerformdata.append("company_address_line_1"	, this.state.company_address_line_1)
    warehouseOwnerformdata.append("company_address_line_2"	, this.state.company_address_line_2)
    warehouseOwnerformdata.append("company_city"	, this.state.company_city)
    warehouseOwnerformdata.append("company_state", this.state.company_state)
    warehouseOwnerformdata.append("company_country"	, this.state.countryId)
    warehouseOwnerformdata.append("company_zip"	, this.state.company_zip)
    warehouseOwnerformdata.append("origin_contact_name"	, this.state.origin_contact_name)
    warehouseOwnerformdata.append("origin_email_id", this.state.origin_email_id)
    warehouseOwnerformdata.append("origin_mobile_no"	, this.state.origin_mobile_no)
    warehouseOwnerformdata.append("origin_address_line_1"	, this.state.origin_address_line_1)
    warehouseOwnerformdata.append("origin_address_line_2"	, this.state.origin_address_line_2)
    warehouseOwnerformdata.append("origin_city", this.state.origin_city)
    warehouseOwnerformdata.append("origin_state"	, this.state.origin_state)
    if (this.state.countryId_origin === null)
    {
    warehouseOwnerformdata.append("origin_country"	, "1")
    }
    else{
    warehouseOwnerformdata.append("origin_country"	, this.state.countryId_origin)
    }
    warehouseOwnerformdata.append("origin_zip"	, this.state.origin_zip)
    warehouseOwnerformdata.append("destination_contact_name", this.state.destination_contact_name)
    warehouseOwnerformdata.append("destination_email_id"	, this.state.destination_email_id)
    warehouseOwnerformdata.append("destination_mobile_no"	, this.state.destination_mobile_no)
    warehouseOwnerformdata.append("destination_address_line_1"	, this.state.destination_address_line_1)
    warehouseOwnerformdata.append("destination_address_line_2", this.state.destination_address_line_2)
    warehouseOwnerformdata.append("destination_city"	, this.state.destination_city)
    warehouseOwnerformdata.append("destination_state"	, this.state.destination_state)
    warehouseOwnerformdata.append("destination_country"	, this.state.countryId_destination)
    warehouseOwnerformdata.append("destination_zip", this.state.destination_zip)
    warehouseOwnerformdata.append("shipping_method"	, this.state.shipping_method)
    warehouseOwnerformdata.append("shipping_priority"	, this.state.shipping_priority)
    warehouseOwnerformdata.append("reverse_shipping"	, this.state.reverse_shipping)
    warehouseOwnerformdata.append("email_notification", this.state.email_notification)
    warehouseOwnerformdata.append("email_use_existing"	, this.state.email_use_existing)
    warehouseOwnerformdata.append("email_client_id"	, this.state.email_client_id)
    warehouseOwnerformdata.append("email_secret"	, this.state.email_secret)
    warehouseOwnerformdata.append("email_authority", this.state.email_authority)
    warehouseOwnerformdata.append("email_to"	, this.state.email_to)
    warehouseOwnerformdata.append("email_bcc"	, this.state.email_bcc)
    warehouseOwnerformdata.append("email_cc"	, this.state.email_cc)
    warehouseOwnerformdata.append("email_scope", this.state.email_scope)
    warehouseOwnerformdata.append("email_end_point"	, this.state.email_end_point)
    warehouseOwnerformdata.append("email_sendemail_endpoint"	, this.state.email_sendemail_endpoint)
    warehouseOwnerformdata.append("whatsapp_notification"	, this.state.whatsapp_notification)
    warehouseOwnerformdata.append("whatsapp_existing", this.state.whatsapp_existing)
    warehouseOwnerformdata.append("from_number"	, this.state.from_number)
    warehouseOwnerformdata.append("whatsapp_token"	, this.state.whatsapp_token)
    warehouseOwnerformdata.append("whatsapp_secret"	, this.state.whatsapp_secret)
    warehouseOwnerformdata.append("whatsapp_url", this.state.whatsapp_url)
    warehouseOwnerformdata.append("broker"	, this.state.broker)
    warehouseOwnerformdata.append("broker_contact_name"	, this.state.broker_contact_name)
    warehouseOwnerformdata.append("broker_email"	, this.state.broker_email)
    warehouseOwnerformdata.append("broker_mobile_no", this.state.broker_mobile_no)
    warehouseOwnerformdata.append("broker_address_line_1"	, this.state.broker_address_line_1)
    warehouseOwnerformdata.append("broker_address_line_2"	, this.state.broker_address_line_2)
    warehouseOwnerformdata.append("broker_city"	, this.state.broker_city)
    warehouseOwnerformdata.append("broker_state", this.state.broker_state)
    warehouseOwnerformdata.append("broker_country"	, this.state.countryId_broker)
    warehouseOwnerformdata.append("broker_zip"	, this.state.broker_zip)
    warehouseOwnerformdata.append("broker_tax_id"	, this.state.broker_tax_id)
    warehouseOwnerformdata.append("broker_account_no", this.state.broker_account_no)
    warehouseOwnerformdata.append("broker_company_name"	, this.state.broker_company_name)
    warehouseOwnerformdata.append("active"	, this.state.active)
    warehouseOwnerformdata.append("whatsapp_namespace"	, this.state.whatsapp_namespace)
    // warehouseOwnerformdata.append("created_by"	, this.state.created_by	)
    // warehouseOwnerformdata.append("created_on", this.state.created_on	)
    // warehouseOwnerformdata.append("modified_by"	, this.state.modified_by	)
    // warehouseOwnerformdata.append("modified_on"	, this.state.modified_on	)



  // @Todo: APi to be called to save data for state - updateFranciseDetailsDB
  this.addUserCredential();

  try {
    let token = localStorage.getItem("token")
    var config = {
      headers: { 'Content-Type': 'multipart/form-data' , 'Authorization':'Token '+token},
      
    };
    const response = await Axios.put(url, warehouseOwnerformdata, config)

    let itemIndex = parseInt(this.state.mainId) - 1
    this.state.warehouseOwnerDetails.splice(itemIndex, 1, response.data)

    var elem = document.getElementById('addWarehouseOwnerModal')
    var instance = M.Modal.getInstance(elem);
    instance.close();
    M.toast({ html: 'Updated Francise Details Successfully.' , classes: "white-text orange rounded" })
    this.setState({
      warehouseId: "",
      countryId: "",
      city: "",
      warehouseOwnerName: "",
      ownerAddressLine1: "",
      ownerAddressLine2: "",
      ownerEmailID: "",
      ownerContactNumber: "",
      warehouseCountry:"",
      warehouseState:"",
      ownerId:""
    })
    this.setState({
      error: "",
      editRow: false
    })
  } catch (err) {
    this.setState({
      error: "OH Snap! Something is Wrong.Please try again",
      editRow: true
    })
    M.toast({ html: 'Please Try Again!', classes: "white-text red rounded" });

    console.log(err.message)
  }

}
//EDIT OPTION END

   addFranciseToDB = async () => {

    if (this.state.company_name.trim().length == 0 ||
    this.state.contact_person.trim().length == 0 ||
    this.state.company_email.trim().length == 0 ||
    this.state.company_contact_no.trim().length == 0 ||
    this.state.company_address_line_1.trim().length == 0 ||
    this.state.company_address_line_2.trim().length == 0 ||
    this.state.company_city.trim().length == 0 ||
    this.state.company_zip.trim().length == 0  )
    {
      alert("All Company Detail fields are mandatory!")
      return;
    }
    let url = base_url+'franchisemaster/'  

    var warehouseOwnerformdata = new FormData()
    // warehouseOwnerformdata.append("franchise_id", this.state.franchise_id)
    warehouseOwnerformdata.append("company_name", this.state.company_name)
    warehouseOwnerformdata.append("contact_person"	, this.state.contact_person)
    warehouseOwnerformdata.append("company_email"	, this.state.company_email)
    warehouseOwnerformdata.append("company_contact_no"	, this.state.company_contact_no)
    warehouseOwnerformdata.append("company_logo", this.state.company_logo)
    warehouseOwnerformdata.append("company_address_line_1"	, this.state.company_address_line_1)
    warehouseOwnerformdata.append("company_address_line_2"	, this.state.company_address_line_2)
    warehouseOwnerformdata.append("company_city"	, this.state.company_city)
    warehouseOwnerformdata.append("company_state", this.state.company_state)
    warehouseOwnerformdata.append("company_country"	, this.state.countryId)
    warehouseOwnerformdata.append("company_zip"	, this.state.company_zip)
    warehouseOwnerformdata.append("origin_contact_name"	, this.state.origin_contact_name)
    warehouseOwnerformdata.append("origin_email_id", this.state.origin_email_id)
    warehouseOwnerformdata.append("origin_mobile_no"	, this.state.origin_mobile_no)
    warehouseOwnerformdata.append("origin_address_line_1"	, this.state.origin_address_line_1)
    warehouseOwnerformdata.append("origin_address_line_2"	, this.state.origin_address_line_2)
    warehouseOwnerformdata.append("origin_city", this.state.origin_city)
    
    if (this.state.origin_state === "0")
    {
      warehouseOwnerformdata.append("origin_state"	, "1")
    }
    else{
      warehouseOwnerformdata.append("origin_state"	, this.state.origin_state)
    }
    if (this.state.countryId_origin === "")
    {
      warehouseOwnerformdata.append("origin_country"	, "BS")
    }
    else{
      warehouseOwnerformdata.append("origin_country"	, this.state.countryId_origin)
    }
    warehouseOwnerformdata.append("origin_zip"	, this.state.origin_zip)
    warehouseOwnerformdata.append("destination_contact_name", this.state.destination_contact_name)
    warehouseOwnerformdata.append("destination_email_id"	, this.state.destination_email_id)
    warehouseOwnerformdata.append("destination_mobile_no"	, this.state.destination_mobile_no)
    warehouseOwnerformdata.append("destination_address_line_1"	, this.state.destination_address_line_1)
    warehouseOwnerformdata.append("destination_address_line_2", this.state.destination_address_line_2)
    warehouseOwnerformdata.append("destination_city"	, this.state.destination_city)
    // warehouseOwnerformdata.append("destination_state"	, this.state.destination_state)
    // warehouseOwnerformdata.append("destination_country"	, this.state.countryId_destination)
    if (this.state.destination_state === "0")
    {
      warehouseOwnerformdata.append("destination_state"	, "1")
    }
    else{
      warehouseOwnerformdata.append("destination_state"	, this.state.destination_state)
    }
    if (this.state.countryId_destination === "")
    {
      warehouseOwnerformdata.append("destination_country"	, "BS")
    }
    else{
      warehouseOwnerformdata.append("destination_country"	, this.state.countryId_destination)
    }

    warehouseOwnerformdata.append("destination_zip", this.state.destination_zip)
    warehouseOwnerformdata.append("shipping_method"	, this.state.shipping_method)
    warehouseOwnerformdata.append("shipping_priority"	, this.state.shipping_priority)
    warehouseOwnerformdata.append("reverse_shipping"	, this.state.reverse_shipping)
    warehouseOwnerformdata.append("email_notification", this.state.email_notification)
    warehouseOwnerformdata.append("email_use_existing"	, this.state.email_use_existing)
    warehouseOwnerformdata.append("email_client_id"	, this.state.email_client_id)
    warehouseOwnerformdata.append("email_secret"	, this.state.email_secret)
    warehouseOwnerformdata.append("email_authority", this.state.email_authority)
    warehouseOwnerformdata.append("email_to"	, this.state.email_to)
    warehouseOwnerformdata.append("email_bcc"	, this.state.email_bcc)
    warehouseOwnerformdata.append("email_cc"	, this.state.email_cc)
    warehouseOwnerformdata.append("email_scope", this.state.email_scope)
    warehouseOwnerformdata.append("email_end_point"	, this.state.email_end_point)
    warehouseOwnerformdata.append("email_sendemail_endpoint"	, this.state.email_sendemail_endpoint)
    warehouseOwnerformdata.append("whatsapp_notification"	, this.state.whatsapp_notification)
    warehouseOwnerformdata.append("whatsapp_existing", this.state.whatsapp_existing)
    warehouseOwnerformdata.append("from_number"	, this.state.from_number)
    warehouseOwnerformdata.append("whatsapp_token"	, this.state.whatsapp_token)
    warehouseOwnerformdata.append("whatsapp_secret"	, this.state.whatsapp_secret)
    warehouseOwnerformdata.append("whatsapp_url", this.state.whatsapp_url)
    warehouseOwnerformdata.append("broker"	, this.state.broker)
    warehouseOwnerformdata.append("broker_contact_name"	, this.state.broker_contact_name)
    warehouseOwnerformdata.append("broker_email"	, this.state.broker_email)
    warehouseOwnerformdata.append("broker_mobile_no", this.state.broker_mobile_no)
    warehouseOwnerformdata.append("broker_address_line_1"	, this.state.broker_address_line_1)
    warehouseOwnerformdata.append("broker_address_line_2"	, this.state.broker_address_line_2)
    warehouseOwnerformdata.append("broker_city"	, this.state.broker_city)
    // warehouseOwnerformdata.append("broker_state", this.state.broker_state)
    // warehouseOwnerformdata.append("broker_country"	, this.state.countryId_broker)
    if (this.state.broker_state === "")
    {
      warehouseOwnerformdata.append("broker_state"	, "1")
    }
    else{
      warehouseOwnerformdata.append("broker_state"	, this.state.broker_state)
    }
    if (this.state.countryId_broker === "")
    {
      warehouseOwnerformdata.append("broker_country"	, "BS")
    }
    else{
      warehouseOwnerformdata.append("broker_country"	, this.state.countryId_broker)
    }

    warehouseOwnerformdata.append("broker_zip"	, this.state.broker_zip)
    warehouseOwnerformdata.append("broker_tax_id"	, this.state.broker_tax_id)
    warehouseOwnerformdata.append("broker_account_no", this.state.broker_account_no)
    warehouseOwnerformdata.append("broker_company_name"	, this.state.broker_company_name)
    warehouseOwnerformdata.append("active"	, this.state.active)
    warehouseOwnerformdata.append("whatsapp_namespace"	, this.state.whatsapp_namespace)
    // warehouseOwnerformdata.append("created_by"	, this.state.created_by	)
    // warehouseOwnerformdata.append("created_on", this.state.created_on	)
    // warehouseOwnerformdata.append("modified_by"	, this.state.modified_by	)
    // warehouseOwnerformdata.append("modified_on"	, this.state.modified_on	)
    
    try {
      let token = localStorage.getItem("token")
      var config = {
        headers: { 
        'Content-Type': 'multipart/form-data' , 
        'Authorization':'Token '+token},
        
      };

      const response = await Axios.post(url, warehouseOwnerformdata, config)

      this.state.warehouseOwnerDetails.unshift(response.data)
      this.setState({franchise_id: response.data.franchise_id})
      this.addUserCredential();
      
      var elem = document.getElementById('addWarehouseOwnerModal')
      var instance = M.Modal.getInstance(elem);
      instance.close();
      this.setState({
        warehouseId: "", 
        warehouseOwnerName: "", 
        warehouseState: "",
        city: "", 
        countryId: "", 
        ownerAddressLine1: "",  
        ownerAddressLine2: "",  
        ownerEmailID:"",
        ownerContactNumber:"",
        ownerId:"",
        franchise_id	 :  "",
        company_name	 :  "",
        contact_person	 :  "",
        company_email	 :  "",
        company_contact_no	 :  "",
        company_logo	 :  "logoname",
        company_address_line_1	 :  "",
        company_address_line_2	 :  "",
        company_city	 :  "",
        company_state	 :  "0",
        company_country	 :  "0",
        company_zip	 :  "",
        origin_contact_name	 :  "",
        origin_email_id	 :  "",
        origin_mobile_no	 :  "",
        origin_address_line_1	 :  "",
        origin_address_line_2	 :  "",
        origin_city	 :  "",
        origin_state	 :  "1",
        origin_country	 :  "1",
        origin_zip	 :  "",
        destination_contact_name	 :  "",
        destination_email_id	 :  "",
        destination_mobile_no	 :  "",
        destination_address_line_1	 :  "",
        destination_address_line_2	 :  "",
        destination_city	 :  "",
        destination_state	 :  "1",
        destination_country	 :  "1",
        destination_zip	 :  "",
        shipping_method	 :  "0",
        shipping_priority	 :  "0",
        reverse_shipping	 :  "0",
        email_notification	 :  "0",
        email_use_existing	 :  "0",
        email_client_id	 :  "",
        email_secret	 :  "",
        email_authority	 :  "",
        email_to	 :  "",
        email_bcc	 :  "",
        email_cc	 :  "",
        email_scope	 :  "",
        email_end_point	 :  "",
        email_sendemail_endpoint	 :  "",
        whatsapp_notification	 :  "0",
        whatsapp_existing	 :  "0",
        from_number	 :  "",
        whatsapp_token	 :  "",
        whatsapp_secret	 :  "",
        whatsapp_url	 :  "",
        broker	 :  "0",
        broker_contact_name	 :  "",
        broker_email	 :  "",
        broker_mobile_no	 :  "",
        broker_address_line_1	 :  "",
        broker_address_line_2	 :  "",
        broker_city	 :  "",
        broker_state	 :  "1",
        broker_country	 :  "1",
        broker_zip	 :  "",
        broker_tax_id	 :  "",
        broker_account_no	 :  "",
        broker_company_name	 :  "",
        active	 :  "1",
        created_by	 :  "1",
        created_on	 :  "",
        modified_by	 :  "1",
        modified_on	 :  "",
        whatsapp_namespace: ""
      })
    
      M.toast({ html: 'Added Francise Successfully ', classes: "white-text orange rounded" })


    } catch (err) {
      this.setState({
        error: "OH Snap! Something is Wrong.Please try again"
      })
      M.toast({ html: 'Please Try Again!', classes: "white-text red rounded" });


    }

 
  }

  handleFileChange = (event) => {
    alert(event.target.files[0])
    //setFile(event.target.files[0]);
  };
  componentDidMount() {
    // Auto initialize all the things!
    M.AutoInit();
  }

  updateWarehouseDetailsDB = async () => {

    let country_code = this.state.countrycodelist[this.state.countrylist.indexOf(this.state.countryName)]
    let url = base_url+`warehouses/${this.state.keyId}/`
  
  //   // console.log(this.state.statename + this.state.statecode + this.state.countryname)
  //   var warehouseformdata = new FormData()
  //   warehouseformdata.append("warehouse_id", this.state.warehouseId)
  //   warehouseformdata.append("name", this.state.warehouseName)
  //   warehouseformdata.append("address", this.state.address)
  //   warehouseformdata.append("city", this.state.city)
  //   warehouseformdata.append("zipcode", this.state.zipcode)
  //   warehouseformdata.append("country", country_code)
  //   warehouseformdata.append("state", this.state.warehouseState)
  //   warehouseformdata.append("status", "Active")
  // console.log(this.state.warehouseState,"uuuuuuuuuuuuuuu")
  //   // @Todo: APi to be called to save data for state
  
  // const sadd1 = this.state.address;
  // const sadd2 = this.state.address2;
  // const scity = this.state.city;
  //  const sstate = this.state.warehouseState;
  // const  scountry = this.state.countryId;
  //  const szipcode = this.state.zipcode; 
  const sadd1 = "add1";
  const sadd2 = "add2";
  const scity = "city";
  const sstate = "1";
  const scountry = "US";
  const szipcode = "111";
  
  const shipformdata={
        address: sadd1,
        address_2: sadd2,
        city: scity,
        state: sstate,
        zipcode: szipcode,
      }
  
    try {
        // const billing_formdata={
        //   address_line_1: sadd1, 
        //   address_line_2: sadd2, 
        //   city: scity,
        //   state: sstate,
        //   zipcode: szipcode,
        //   country:scountry,
        //   ezz_id: Id,
        // }
  
      console.log(shipformdata);
      //console.log(billing_formdata);
  
       await Axios({
        method: 'PATCH',
        url: base_url+`customers/${this.state.keyId}/`,
        data: shipformdata,
        headers: { 'Content-Type': 'application/json' }
      })
        .then(async function (response) {
  
              // await Axios({
              //   method: 'POST',
              //   url: base_url+`customer_billing_address/`,
              //   data: billing_formdata,
              //   headers: { 'Content-Type': 'application/json' }
              // }).then((response) => {
              //   console.log(response)
                      
              // }).catch((response) => {
              //   console.log(response)
              // })
  
          console.log(response.data)
  
        })
        .catch(function (response) {
          //handle error
          console.log(response);
          console.log('error')
  
        });
  
      // let token = localStorage.getItem("token")
      // var config = {
      //   headers: { 'Content-Type': 'multipart/form-data' , 'Authorization':'Token '+token},
        
      // };
      // const response = await Axios.put(url, warehouseformdata, config)
      
      // let itemIndex = parseInt(this.state.mainId) - 1
      // this.state.sitedata.splice(itemIndex, 1, response.data)
      
      // this.state.sitedata.unshift(response.data)
      var elem = document.getElementById('addWareHouseModal')
      var instance = M.Modal.getInstance(elem);
      instance.close();
      M.toast({ html: 'Updated Crew Successfully.' , classes: "white-text orange rounded" })
      this.setState({
        warehouseId: "", warehouseName: "", address: "", address2: "", countryName:"", pwd: "", confpwd: "", phone: "",
        countryId: "", warehouseState: "", city: "", zipcode: ""
      })
      this.setState({
        error: "",
        editRow: false
      })
    } catch (err) {
      this.setState({
        error: "OH Snap! Something is Wrong.Please try again",
        editRow: false
      })
      M.toast({ html: 'Please Try Again!', classes: "white-text red rounded" });
  
      console.log(err.message)
    }
  
  }
  //EDIT OPTION END
  
    addUserCredential = async () => {
      // if (this.state.confpwd !== this.state.pwd)
      // {
      //   M.toast({ html: 'Password Not Same', classes: "white-text orange rounded" })
      //   return
      // }
  
      // let state_code = this.state.countrycodelist[this.state.countrylist.indexOf(this.state.warehouseState)]
      // console.log(state_code);

  const sadd1 = this.state.company_address_line_1;
  const sadd2 =  this.state.company_address_line_2;
  const scity = this.state.company_city;
  const sstate = this.state.company_state;
  const scountry = this.state.countryId;
  const szipcode = this.state.company_zip;
  const sname = this.state.company_name;
  const sphone = this.state.company_contact_no;
  const semail = this.state.company_email;
  const sfrancid = this.state.franchise_id;

  const operatorformdata={
    address: sadd1, 
    phone_number: sphone, 
    email: semail,
    operator_id: sfrancid,
    title: "Francise",
    name: sname,
    country_resident:scountry,
    country_work:scountry,
    status: "Active",
    flag: 1,
  }

  const shipformdata={
        address: sadd1,
        address_2: sadd2,
        city: scity,
        state: sstate,
        zipcode: szipcode,
      }
  
      
  
  const formdata={
    name: this.state.company_name,
    phone_number: this.state.company_contact_no,
    email: this.state.company_email,
    country: scountry,
    ezz_id: this.state.franchise_id
  }
  
    const newdata={
      email: this.state.company_email,
      password: this.state.franchise_id,
      security_question: "First Dog?",
      security_answer: "romie",
      is_staff: "True",
      is_operator: "True",
      role_id: "5"
    }

    console.log(formdata);
    console.log(newdata);
     await Axios({
      method: 'post',
      url: base_url+'customerswithezzid/',
      data:formdata,
      headers: {'Content-Type': 'application/json' }
      })
      .then(async function (response) {
          //handle success
          console.log(response);
          console.log('success');
          const {data}=response;
          const Id=data.ezz_id;
          console.log(`Ezz ID created is ${Id}`);

          
          await Axios({
            method: 'POST',
            url: base_url+`operators/`,
            data: operatorformdata,
            headers: { 'Content-Type': 'application/json' }
          })

           await Axios({
            method:'post',
            url:base_url+'create_user/',
            data: newdata,
            headers: {'Content-Type': 'application/json' }
          }).then(function(response){
            console.log(response);
            console.log('django success');
             M.toast({ html: 'Added User Successfully ', classes: "white-text orange rounded" })
            //  var elem = document.getElementById('addWareHouseModal')
            // var instance = M.Modal.getInstance(elem);
            // instance.close();
            this.setState({
            warehouseId: "", warehouseName: "", address: "", address2: "",phone: "",pwd: "",confpwd: "",
            countryId: "", warehouseState: "", city: "", zipcode: "",
            warehouseStateId:"", 
            error:""
            })
            }).catch(function(response){
            console.log(response)
            console.log('inner api failed')
          })
  
      const billing_formdata={
        address_line_1: sadd1, 
        address_line_2: sadd2, 
        city: scity,
        state: sstate,
        zipcode: szipcode,
        country:scountry,
        ezz_id: Id,
      }
  
      console.log(shipformdata);
      console.log(billing_formdata);
  
       await Axios({
        method: 'PATCH',
        url: base_url+`customers/${Id}/`,
        data: shipformdata,
        headers: { 'Content-Type': 'application/json' }
      })
        .then(async function (response) {
  
               await Axios({
                method: 'POST',
                url: base_url+`customer_billing_address/`,
                data: billing_formdata,
                headers: { 'Content-Type': 'application/json' }
              }).then(async function (response)  {
                console.log(response)
                

              }).catch((response) => {
                console.log(response)
              })
  
          console.log(response.data)
  
        })
        .catch(function (response) {
          //handle error
          console.log(response);
          console.log('error')
  
        });
  
      
      }).catch(function (response) {
          M.toast({ html: 'User already exist ', classes: "white-text orange rounded" })
          console.log('error')     
      });
      
    }

  render() {
    var warehouseIDkey = 0
    var countrykey = 0
    var statekey = 0

    // const selectWarehouseIDOptions = this.state.warehouseIdList.map((wID) => {

    //   return (
    //     <option key={warehouseIDkey++} value={wID}>{wID}</option>
    //   )
    // })

    const selectCounrtyOptions = this.state.countrylist.map((country) => {

      return (
        <option key={countrykey++} value={country}>{country}</option>
      )
    })

    const selectStateOptions = this.state.statelist.map((state) => {

      return (

        <option key={"_" + statekey++} value={state.state_id}>{state.state_name}</option>
      )
    })

    const selectCounrtyOptions_origin = this.state.countrylist.map((country) => {

      return (
        <option key={countrykey++} value={country}>{country}</option>
      )
    })

    const selectStateOptions_origin = this.state.statelist_origin.map((state) => {

      return (

        <option key={"_" + statekey++} value={state.state_id}>{state.state_name}</option>
      )
    })

    const selectCounrtyOptions_destination = this.state.countrylist.map((country) => {

      return (
        <option key={countrykey++} value={country}>{country}</option>
      )
    })

    const selectStateOptions_destination = this.state.statelist_destination.map((state) => {

      return (

        <option key={"_" + statekey++} value={state.state_id}>{state.state_name}</option>
      )
    })

    const selectCounrtyOptions_broker = this.state.countrylist.map((country) => {

      return (
        <option key={countrykey++} value={country}>{country}</option>
      )
    })

    const selectStateOptions_broker = this.state.statelist_broker.map((state) => {

      return (

        <option key={"_" + statekey++} value={state.state_id}>{state.state_name}</option>
      )
    })

    var sr_no= 0;
    let address;
    const WarehouseOwnerTable = this.state.warehouseOwnerDetails.map((owner) => {
      sr_no=sr_no+1;
      // address = owner.address2 === null ? owner.address1 : owner.address1 + " " + owner.address2;
      // this.state.address1.push(owner.address1);
      // this.state.address2 = owner.address2 ;
      
      return (
        <Fragment key = {sr_no}>
          <tr >
            <td onClick={this.handleEditOption}><a title="Edit"><EditOutlined /></a></td>
            <td className="hide">{owner.id}</td>
            <td>{sr_no}</td>
            <td>{owner.franchise_id}</td>
            <td>{owner.company_name}</td>
            <td>{owner.contact_person}</td>
            <td>{owner.company_email}</td>
            <td>{owner.company_contact_no}</td>
            <td>{owner.company_logo}</td>
            {/* <td>{address}</td> */}
            <td>{owner.company_address_line_1}</td>
            <td>{owner.company_address_line_2}</td>
            {/* <td>{owner.address2 === null ? owner.address1 : owner.address1 + owner.address2}</td> */}
            <td>{owner.company_city}</td>
            <td>{owner.company_state}</td>
            <td>{owner.company_country}</td>
            <td>{owner.company_zip}</td>

            <td>{owner.shipping_method}</td>
            <td>{owner.shipping_priority}</td>
            <td>{owner.reverse_shipping}</td>
            <td>{owner.email_notification}</td>
            <td>{owner.whatsapp_notification}</td>
            <td>{owner.active}</td>
            <td className="hide">{owner.origin_contact_name}</td>
            <td className="hide">{owner.origin_email_id}</td>
            <td className="hide">{owner.origin_mobile_no}</td>
            <td className="hide">{owner.origin_address_line_1}</td>
            <td className="hide">{owner.origin_address_line_2}</td>
            <td className="hide">{owner.origin_city}</td>
            <td className="hide">{owner.origin_state}</td>
            <td className="hide">{owner.origin_country}</td>
            <td className="hide">{owner.origin_zip}</td>
            
            <td className="hide">{owner.destination_contact_name}</td>
            <td className="hide">{owner.destination_email_id}</td>
            <td className="hide">{owner.destination_mobile_no}</td>
            <td className="hide">{owner.destination_address_line_1}</td>
            <td className="hide">{owner.destination_address_line_2}</td>
            <td className="hide">{owner.destination_city}</td>
            <td className="hide">{owner.destination_state}</td>
            <td className="hide">{owner.destination_country}</td>
            <td className="hide">{owner.destination_zip}</td>

            <td className="hide">{owner.broker}</td>
            <td className="hide">{owner.broker_contact_name}</td>
            <td className="hide">{owner.broker_email}</td>
            <td className="hide">{owner.broker_mobile_no}</td>
            <td className="hide">{owner.broker_address_line_1}</td>
            <td className="hide">{owner.broker_address_line_2}</td>
            <td className="hide">{owner.broker_city}</td>
            <td className="hide">{owner.broker_state}</td>
            <td className="hide">{owner.broker_country}</td>
            <td className="hide">{owner.broker_zip}</td>
            <td className="hide">{owner.broker_tax_id}</td>
            <td className="hide">{owner.broker_account_no}</td>
            <td className="hide">{owner.broker_company_name}</td>


            <td className="hide">{owner.email_use_existing}</td>
            <td className="hide">{owner.email_client_id}</td>
            <td className="hide">{owner.email_secret}</td>
            <td className="hide">{owner.email_authority}</td>
            <td className="hide">{owner.email_to}</td>
            <td className="hide">{owner.email_bcc}</td>
            <td className="hide">{owner.email_cc}</td>
            <td className="hide">{owner.email_scope}</td>
            <td className="hide">{owner.email_end_point}</td>
            <td className="hide">{owner.email_sendemail_endpoint}</td>

            <td className="hide">{owner.whatsapp_existing}</td>
            <td className="hide">{owner.from_number}</td>
            <td className="hide">{owner.whatsapp_token}</td>
            <td className="hide">{owner.whatsapp_secret}</td>
            <td className="hide">{owner.whatsapp_url}</td>
            <td className="hide">{owner.whatsapp_namespace}</td>
            

          </tr>
        </Fragment>

      )
    })

    const table_render = <Table hover >
      <thead>
        <tr>
          <th>Edit</th>
          <th className="hide">Id-Hide</th>
          <th>Sr.No.</th>
          <th>Franchise ID</th>
          <th>Company Name</th>
          <th>Company Contact</th>
          <th>Company Email</th>
          <th>Company No.</th>
          <th>Company Logo</th>
          <th>Address Line 1</th>
          <th>Address Line 2</th>
          <th>Company City</th>
          <th>Company State</th>
          <th>Company Country</th>
          <th>Company ZIP</th>

          <th>Shipping Method</th>
            <th>Shipping Priority</th>
            <th>Reverse Shipping</th>
            <th>Email Notification</th>
            <th>Whatsapp Notification</th>
            <th>Active</th>

            <th className="hide">Origin Contact</th>
            <th className="hide">Origin Email</th>
            <th className="hide">Origin Mobile</th>
            <th className="hide">Origin Address1</th>
            <th className="hide">Origin Address2</th>
            <th className="hide">Origin City</th>
            <th className="hide">Origin State</th>
            <th className="hide">Origin Country</th>
            <th className="hide">Origin Zip</th>
            
            <th className="hide">Dest. Contact</th>
            <th className="hide">Dest. Email</th>
            <th className="hide">Dest. Mobile</th>
            <th className="hide">Dest. Address1</th>
            <th className="hide">Dest. Address2</th>
            <th className="hide">Dest. City</th>
            <th className="hide">Dest. State</th>
            <th className="hide">Dest. Country</th>
            <th className="hide">Dest. Zip</th>

            <th className="hide">Broker</th>
            <th className="hide">Broker Contact</th>
            <th className="hide">Broker Email</th>
            <th className="hide">Broker Mobile</th>
            <th className="hide">Broker Address1</th>
            <th className="hide">Broker_ Address2</th>
            <th className="hide">Broker City</th>
            <th className="hide">Broker State</th>
            <th className="hide">Broker Country</th>
            <th className="hide">Broker Zip</th>
            <th className="hide">Broker Taxid</th>
            <th className="hide">Broker Account</th>
            <th className="hide">Broker Company</th>


            <th className="hide">Email Use Existing</th>
            <th className="hide">Email Clientid</th>
            <th className="hide">Email Secret</th>
            <th className="hide">Email Authority</th>
            <th className="hide">Email To</th>
            <th className="hide">Email Bcc</th>
            <th className="hide">Email Cc</th>
            <th className="hide">Email Scope</th>
            <th className="hide">End Point</th>
            <th className="hide">Sende Endpoint</th>

            <th className="hide">Whatsapp Existing</th>
            <th className="hide">From Number</th>
            <th className="hide">Whatsapp Token</th>
            <th className="hide">Whatsapp Secret</th>
            <th className="hide">Whatsapp URL</th>
            <th className="hide">Whatsapp Namespace</th>

        </tr>
      </thead>
      <tbody>
            {WarehouseOwnerTable}
      </tbody>
    </Table>

    return (
      <Fragment>
        <br></br>
        <br></br>
       
      


        {/* <!-- Modal Trigger --> */}
        <div id="addWarehouseOwnerModal" className="modal modal-fixed-footer warehouseownarMadal">
          <div className="modal-content">
            
            
          <h4 className="center orange-text"> {this.state.editRow ? "Update Francise Details" : "Add Francise Details"}</h4>

             {/* <!-- Company Detail Div Start --> */}
            <div id="divcompanydetail">
            <h5 className="center blue-text">Company Detail</h5>
            <Row>
              <Col xs={12} >
                <form>
                  <p className="center red-text">{this.state.error}</p>

                  {/* <Row>
                    <Col className=" rowdivPading " xs={12}>
                      <div className="input-field col s6 offset-s3">
                        <div id=''>
                          {
                            this.state.editRow
                            ? <select id="warehouse_id_selct" name="warehouseid" className="browser-default warehouseID_select" value={this.state.warehouseId} onChange={this.handleWarehouseIdChange}>
                              <option value="" disabled >Choose WarehouseID </option>
                              {selectWarehouseIDOptions}

                            </select>
                            : <select id="warehouse_id_selct" name="warehouseid" className="browser-default warehouseID_select" defaultValue={'DEFAULT'} onChange={this.handleWarehouseIdChange}>
                              <option value="DEFAULT" disabled >Choose WarehouseID </option>
                              {selectWarehouseIDOptions}

                            </select>
                          }
                          <label>Select WarehouseID</label>

                        </div>
                      </div>  
                    </Col>
                  </Row> */}
                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input disabled name="franchise_id" id="franchise_id" className="materialize-textarea" type="text" value={this.state.franchise_id} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="franchise_id" className={this.state.franchise_id?"black-text active":"black-text"}>Francise Id</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Francise Id: Auto Generated</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="company_name" id="company_name" className="materialize-textarea" type="text" value={this.state.company_name} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="company_name" className={this.state.warehouseOwnerName?"black-text active":"black-text"}>Enter Company Name</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Company Name</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="contact_person" id="contact_person" className="materialize-textarea" type="text" value={this.state.contact_person} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="contact_person" className={this.state.contact_person?"black-text active":"black-text"}>Enter Contact Name</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Contact Name</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="company_address_line_1" id="company_address_line_1" className="materialize-textarea" type="text" value={this.state.company_address_line_1} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="company_address_line_1" className={this.state.company_address_line_1?"black-text active":"black-text"}>Enter Address Line 1</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Address line 1</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="company_address_line_2" id="company_address_line_2" className="materialize-textarea" type="text" value={this.state.company_address_line_2} 
                         onChange={this.handleFormChange}  />
                        <label htmlFor="company_address_line_2" className={this.state.ownerAddressLine2?"black-text active":"black-text"}>Enter Address Line 2</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Address line 2</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="company_city" id="company_city" type="text" className="" value={this.state.company_city} 
                        onChange={this.handleFormChange} />
                        <label htmlFor="company_city" className={this.state.company_city?"black-text active":"black-text"}>Enter Company City</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Company City Ex: Miami</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading " xs={12}>
                      <div className="input-field col s6 offset-s3">
                        <div >
                        {
                            this.state.editRow
                            ? <select id="company_country" name="company_country" className="browser-default country_name_select" value={this.state.company_country} onChange={this.handleCountryNameChange}>
                              <option value="" disabled >Choose Company Country </option>
                              {selectCounrtyOptions}

                            </select>
                            : <select id="company_country" name="company_country" className="browser-default country_name_select" defaultValue={'DEFAULT'} onChange={this.handleCountryNameChange}>
                              <option value="DEFAULT" disabled >Choose Company Country </option>
                              {selectCounrtyOptions}

                            </select>
                          }
                          <label>Select Country</label>

                        </div>
                      </div>  </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading " xs={12}>
                      <div className="input-field col s6 offset-s3">
                        <div>
                        {
                          this.state.editRow
                            ? <select id="company_state" name="company_state" className="browser-default " value={this.state.company_state} onChange={this.handleStateChange}>
                              <option value="" disabled >Choose Company state</option>
                              {selectStateOptions}
                            </select>
                            : <select id="company_state" name="company_state" className="browser-default " defaultValue={'DEFAULT'} onChange={this.handleStateChange}>
                              <option value="DEFAULT" disabled >Choose Company state</option>
                              {selectStateOptions}
                            </select>
                        }
                          <label>Select state</label>

                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="company_zip" id="company_zip" className="materialize-textarea" type="text"  value={this.state.company_zip}
                          onChange={this.handleFormChange} />
                        <label htmlFor="company_zip" className={this.state.company_zip?"black-text active":"black-text"}>Enter ZIP</label>
                        <span className="helper-text left" data-error="wrong" data-success="">ZIP</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="company_email" id="company_email" className="materialize-textarea" type="email" value={this.state.company_email}
                         onChange={this.handleFormChange}  />
                        <label htmlFor="company_email" className={this.state.company_email?"black-text active":"black-text"}>Enter Email ID</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Email id</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="company_contact_no" id="company_contact_no" className="materialize-textarea" type="text"  value={this.state.company_contact_no}
                          onChange={this.handleFormChange} maxLength="10"/>
                        <label htmlFor="company_contact_no" className={this.state.company_contact_no?"black-text active":"black-text"}>Enter Contact Number</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Contact number</span>
                      </div>
                    </Col>
                  </Row>


                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="company_logo" id="company_logo" className="materialize-textarea" type="text"  value={this.state.company_logo}
                          onChange={this.handleFormChange} />
                        <label htmlFor="company_logo" className={this.state.company_logo?"black-text active":"black-text"}>Enter Logo Name</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Logo</span>
                      {/* <input type="file" class="form-control" id="AM_Documents" placeholder=""></input> */}
                      {/* <input type="file" onChange={handleFileChange} /> */}
      {/* <button onClick={handleUpload}>Upload</button> */}
                      </div>
                    </Col>
                  </Row>

                  <Row>
          <Col className=" rowdivPading ">
          <div className="input-field col s6 offset-s3 left">
            <span>Shipping Method</span>
            <span>
            <label>
            <input name="shipping_method" value="0" type="radio"  
            checked={this.state.shipping_method ==="0"} onChange={this.handleFormChange}
            />
            <span>Cash</span>
            </label>
            </span>
            <span>
            <label>
            <input name="shipping_method" value="1" type="radio" 
            checked={this.state.shipping_method ==="1"} onChange={this.handleFormChange} />
            <span>Card</span>
            </label>
            </span>

            </div>
          </Col>
          </Row>

          <Row>
          <Col className=" rowdivPading ">
          <div className="input-field col s12 offset-s3 left">
            <span>Shipping Priority</span>
            <span>
            <label>
            <input name="shipping_priority" value="0" type="radio"  
            checked={this.state.shipping_priority ==="0"} onChange={this.handleFormChange}
            />
            <span>Economy</span>
            </label>
            </span>
            <span>
            <label>
            <input name="shipping_priority" value="1" type="radio" 
            checked={this.state.shipping_priority ==="1"} onChange={this.handleFormChange} />
            <span>Priority</span>
            </label>
            </span>

            </div>
          </Col>
          </Row>

          <Row>
          <Col className=" rowdivPading ">
          <div className="input-field col s6 offset-s3 left">
            <span>Reverse Shipping</span>
            <span>
            <label>
            <input name="reverse_shipping" value="1" type="radio"  
            checked={this.state.reverse_shipping ==="1"} onChange={this.handleFormChange}
            />
            <span>YES</span>
            </label>
            </span>
            <span>
            <label>
            <input name="reverse_shipping" value="0" type="radio" 
            checked={this.state.reverse_shipping ==="0"} onChange={this.handleFormChange} />
            <span>NO</span>
            </label>
            </span>

            </div>
          </Col>
          </Row>

          <Row>
          <Col className=" rowdivPading ">
          <div className="input-field col s6 offset-s3 left">
            <span>Email Notification</span>
            <span>
            <label>
            <input name="email_notification" value="1" type="radio"  
            checked={this.state.email_notification ==="1"} onChange={this.handleFormChange}
            />
            <span>YES</span>
            </label>
            </span>
            <span>
            <label>
            <input name="email_notification" value="0" type="radio" 
            checked={this.state.email_notification ==="0"} onChange={this.handleFormChange} />
            <span>NO</span>
            </label>
            </span>

            </div>
          </Col>
          </Row>

          <Row>
          <Col className=" rowdivPading ">
          <div className="input-field col s12 offset-s3 left">
            <span>WhatsApp Notification</span>
            <span>
            <label>
            <input name="whatsapp_notification" value="1" type="radio"  
            checked={this.state.whatsapp_notification ==="1"} onChange={this.handleFormChange}
            />
            <span>YES</span>
            </label>
            </span>
            <span>
            <label>
            <input name="whatsapp_notification" value="0" type="radio" 
            checked={this.state.whatsapp_notification ==="0"} onChange={this.handleFormChange} />
            <span>NO</span>
            </label>
            </span>

            </div>
          </Col>
          </Row>

          <Row>
          <Col className=" rowdivPading ">
          <div className="input-field col s6 offset-s3 left">
            <span>Active</span>
            <span>
            <label>
            <input name="active" value="1" type="radio"  
            checked={this.state.active ==="1"} onChange={this.handleFormChange}
            />
            <span>YES</span>
            </label>
            </span>
            <span>
            <label>
            <input name="active" value="0" type="radio" 
            checked={this.state.active ==="0"} onChange={this.handleFormChange} />
            <span>NO</span>
            </label>
            </span>

            </div>
          </Col>
          </Row>

                </form>
              </Col>
            </Row>
          </div>
          {/* <!-- Company Detail Div End --> */}

            {/* <!-- Origin Detail Div Start --> */}
            <div id="divorigindetail">
            <h5 className="center blue-text">Origin Detail</h5>
            <Row>
              <Col xs={12} >
                <form>
                  {/* <p className="center red-text">{this.state.error}</p> */}

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="origin_contact_name" id="origin_contact_name" className="materialize-textarea" type="text" value={this.state.origin_contact_name} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="origin_contact_name" className={this.state.origin_contact_name?"black-text active":"black-text"}>Enter Origin Contact Name</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Contact Name</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="origin_address_line_1" id="origin_address_line_1" className="materialize-textarea" type="text" value={this.state.origin_address_line_1} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="origin_address_line_1" className={this.state.origin_address_line_1?"black-text active":"black-text"}>Enter Origin Address Line 1</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Address line 1</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="origin_address_line_2" id="origin_address_line_2" className="materialize-textarea" type="text" value={this.state.origin_address_line_2} 
                         onChange={this.handleFormChange}  />
                        <label htmlFor="origin_address_line_2" className={this.state.origin_address_line_2?"black-text active":"black-text"}>Enter Origin Address Line 2</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Address line 2</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="origin_city" id="origin_city" type="text" className="" value={this.state.origin_city} 
                        onChange={this.handleFormChange} />
                        <label htmlFor="origin_city" className={this.state.origin_city?"black-text active":"black-text"}>Enter Origin City</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Origin City Ex: Miami</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading " xs={12}>
                      <div className="input-field col s6 offset-s3">
                        <div >
                        {
                            this.state.editRow
                            ? <select id="origin_country" name="origin_country" className="browser-default country_name_select" value={this.state.origin_country} onChange={this.handleCountryNameChange_origin}>
                              <option value="" disabled >Choose Origin Country </option>
                              {selectCounrtyOptions_origin}

                            </select>
                            : <select id="origin_country" name="origin_country" className="browser-default country_name_select" defaultValue={'DEFAULT'} onChange={this.handleCountryNameChange_origin}>
                              <option value="DEFAULT" disabled >Choose Origin Country </option>
                              {selectCounrtyOptions_origin}

                            </select>
                          }
                          <label>Select Country</label>

                        </div>
                      </div>  </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading " xs={12}>
                      <div className="input-field col s6 offset-s3">
                        <div>
                        {
                          this.state.editRow
                            ? <select id="origin_state" name="origin_state" className="browser-default " value={this.state.origin_state} onChange={this.handleFormChange}>
                              <option value="" disabled >Choose Origin state</option>
                              {selectStateOptions_origin}
                            </select>
                            : <select id="origin_state" name="origin_state" className="browser-default " defaultValue={'DEFAULT'} onChange={this.handleFormChange}>
                              <option value="DEFAULT" disabled >Choose Origin state</option>
                              {selectStateOptions_origin}
                            </select>
                        }
                          <label>Select state</label>

                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="origin_zip" id="origin_zip" className="materialize-textarea" type="text"  value={this.state.origin_zip}
                          onChange={this.handleFormChange} />
                        <label htmlFor="origin_zip" className={this.state.origin_zip?"black-text active":"black-text"}>Enter Origin ZIP</label>
                        <span className="helper-text left" data-error="wrong" data-success="">ZIP</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="origin_email_id" id="origin_email_id" className="materialize-textarea" type="email" value={this.state.origin_email_id}
                         onChange={this.handleFormChange}  />
                        <label htmlFor="origin_email_id" className={this.state.origin_email_id?"black-text active":"black-text"}>Enter Origin Email ID</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Email id</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="origin_mobile_no" id="origin_mobile_no" className="materialize-textarea" type="text"  value={this.state.origin_mobile_no}
                          onChange={this.handleFormChange} />
                        <label htmlFor="origin_mobile_no" className={this.state.origin_mobile_no?"black-text active":"black-text"}>Enter Origin Contact Number</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Contact number</span>
                      </div>
                    </Col>
                  </Row>

                </form>
              </Col>
            </Row>
          </div>
          {/* <!-- Origin Detail Div End --> */}
          
          {/* <!-- Destination Detail Div Start --> */}
          <div id="divdestinationdetail">
            <h5 className="center blue-text">Destination Detail</h5>
            <Row>
              <Col xs={12} >
                <form>
                  {/* <p className="center red-text">{this.state.error}</p> */}

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="destination_contact_name" id="destination_contact_name" className="materialize-textarea" type="text" value={this.state.destination_contact_name} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="destination_contact_name" className={this.state.destination_contact_name?"black-text active":"black-text"}>Enter Destination Contact Name</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Contact Name</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="destination_address_line_1" id="destination_address_line_1" className="materialize-textarea" type="text" value={this.state.destination_address_line_1} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="destination_address_line_1" className={this.state.destination_address_line_1?"black-text active":"black-text"}>Enter Destination Address Line 1</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Address line 1</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="destination_address_line_2" id="destination_address_line_2" className="materialize-textarea" type="text" value={this.state.destination_address_line_2} 
                         onChange={this.handleFormChange}  />
                        <label htmlFor="destination_address_line_2" className={this.state.destination_address_line_2?"black-text active":"black-text"}>Enter Destination Address Line 2</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Address line 2</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="destination_city" id="destination_city" type="text" className="" value={this.state.destination_city} 
                        onChange={this.handleFormChange} />
                        <label htmlFor="destination_city" className={this.state.destination_city?"black-text active":"black-text"}>Enter Destination City</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Origin City Ex: Miami</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading " xs={12}>
                      <div className="input-field col s6 offset-s3">
                        <div >
                        {
                            this.state.editRow
                            ? <select id="destination_country" name="destination_country" className="browser-default country_name_select" value={this.state.destination_country} onChange={this.handleCountryNameChange_destination}>
                              <option value="" disabled >Choose Destination Country </option>
                              {selectCounrtyOptions_destination}

                            </select>
                            : <select id="destination_country" name="destination_country" className="browser-default country_name_select" defaultValue={'DEFAULT'} onChange={this.handleCountryNameChange_destination}>
                              <option value="DEFAULT" disabled >Choose Destination Country </option>
                              {selectCounrtyOptions_destination}

                            </select>
                          }
                          <label>Select Country</label>

                        </div>
                      </div>  </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading " xs={12}>
                      <div className="input-field col s6 offset-s3">
                        <div>
                        {
                          this.state.editRow
                            ? <select id="destination_state" name="destination_state" className="browser-default " value={this.state.destination_state} onChange={this.handleFormChange}>
                              <option value="" disabled >Choose Destination state</option>
                              {selectStateOptions_destination}
                            </select>
                            : <select id="destination_state" name="destination_state" className="browser-default " defaultValue={'DEFAULT'} onChange={this.handleFormChange}>
                              <option value="DEFAULT" disabled >Choose Destination state</option>
                              {selectStateOptions_destination}
                            </select>
                        }
                          <label>Select state</label>

                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="destination_zip" id="destination_zip" className="materialize-textarea" type="text"  value={this.state.destination_zip}
                          onChange={this.handleFormChange} />
                        <label htmlFor="destination_zip" className={this.state.destination_zip?"black-text active":"black-text"}>Enter Destination ZIP</label>
                        <span className="helper-text left" data-error="wrong" data-success="">ZIP</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="destination_email_id" id="destination_email_id" className="materialize-textarea" type="email" value={this.state.destination_email_id}
                         onChange={this.handleFormChange}  />
                        <label htmlFor="destination_email_id" className={this.state.destination_email_id?"black-text active":"black-text"}>Enter Destination Email ID</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Email id</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="destination_mobile_no" id="destination_mobile_no" className="materialize-textarea" type="text"  value={this.state.destination_mobile_no}
                          onChange={this.handleFormChange} />
                        <label htmlFor="destination_mobile_no" className={this.state.destination_mobile_no?"black-text active":"black-text"}>Enter Destination Contact Number</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Contact number</span>
                      </div>
                    </Col>
                  </Row>

                </form>
              </Col>
            </Row>
          </div>
          {/* <!-- Destination Detail Div End --> */}

{/* <!-- Broker Detail Div Start --> */}
      <div id="divbrokerdetail">
            <h5 className="center blue-text">Broker Detail</h5>
            <Row>
          <Col className=" rowdivPading ">
          <div className="input-field col s6 offset-s3 left">
            <span>Broker Select</span>
            <span>
            <label>
            <input name="broker" value="1" type="radio"  
            checked={this.state.broker ==="1"} onChange={this.handleFormChange}
            />
            <span>YES</span>
            </label>
            </span>
            <span>
            <label>
            <input name="broker" value="0" type="radio" 
            checked={this.state.broker ==="0"} onChange={this.handleFormChange} />
            <span>NO</span>
            </label>
            </span>

            </div>
          </Col>
          </Row>
            <Row>
              <Col xs={12} >
                <form>
                  {/* <p className="center red-text">{this.state.error}</p> */}
                  
                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="broker_tax_id" id="broker_tax_id" className="materialize-textarea" type="text" value={this.state.broker_tax_id} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="broker_tax_id" className={this.state.broker_tax_id?"black-text active":"black-text"}>Enter Broker Tax Id</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Tax Id</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="broker_account_no" id="broker_account_no" className="materialize-textarea" type="text" value={this.state.broker_account_no} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="broker_account_no" className={this.state.broker_account_no?"black-text active":"black-text"}>Enter Broker Account No</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Account No</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="broker_company_name" id="broker_company_name" className="materialize-textarea" type="text" value={this.state.broker_company_name} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="broker_company_name" className={this.state.broker_company_name?"black-text active":"black-text"}>Enter Broker Company Name</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Company Name</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="broker_contact_name" id="broker_contact_name" className="materialize-textarea" type="text" value={this.state.broker_contact_name} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="broker_contact_name" className={this.state.broker_contact_name?"black-text active":"black-text"}>Enter Broker Contact Name</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Contact Name</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="broker_address_line_1" id="broker_address_line_1" className="materialize-textarea" type="text" value={this.state.broker_address_line_1} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="broker_address_line_1" className={this.state.broker_address_line_1?"black-text active":"black-text"}>Enter Broker Address Line 1</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Address line 1</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="broker_address_line_2" id="broker_address_line_2" className="materialize-textarea" type="text" value={this.state.broker_address_line_2} 
                         onChange={this.handleFormChange}  />
                        <label htmlFor="broker_address_line_2" className={this.state.broker_address_line_2?"black-text active":"black-text"}>Enter Broker Address Line 2</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Address line 2</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="broker_city" id="broker_city" type="text" className="" value={this.state.broker_city} 
                        onChange={this.handleFormChange} />
                        <label htmlFor="broker_city" className={this.state.broker_city?"black-text active":"black-text"}>Enter Broker City</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Broker City Ex: Miami</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading " xs={12}>
                      <div className="input-field col s6 offset-s3">
                        <div >
                        {
                            this.state.editRow
                            ? <select id="broker_country" name="broker_country" className="browser-default country_name_select" value={this.state.broker_country} onChange={this.handleCountryNameChange_broker}>
                              <option value="" disabled >Choose Broker Country </option>
                              {selectCounrtyOptions_broker}

                            </select>
                            : <select id="broker_country" name="broker_country" className="browser-default country_name_select" defaultValue={'DEFAULT'} onChange={this.handleCountryNameChange_broker}>
                              <option value="DEFAULT" disabled >Choose Broker Country </option>
                              {selectCounrtyOptions_broker}

                            </select>
                          }
                          <label>Select Country</label>

                        </div>
                      </div>  </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading " xs={12}>
                      <div className="input-field col s6 offset-s3">
                        <div>
                        {
                          this.state.editRow
                            ? <select id="broker_state" name="broker_state" className="browser-default " value={this.state.broker_state} onChange={this.handleFormChange}>
                              <option value="" disabled >Choose Broker state</option>
                              {selectStateOptions_broker}
                            </select>
                            : <select id="broker_state" name="broker_state" className="browser-default " defaultValue={'DEFAULT'} onChange={this.handleFormChange}>
                              <option value="DEFAULT" disabled >Choose Broker state</option>
                              {selectStateOptions_broker}
                            </select>
                        }
                          <label>Select state</label>

                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="broker_zip" id="broker_zip" className="materialize-textarea" type="text"  value={this.state.broker_zip}
                          onChange={this.handleFormChange} />
                        <label htmlFor="broker_zip" className={this.state.broker_zip?"black-text active":"black-text"}>Enter Broker ZIP</label>
                        <span className="helper-text left" data-error="wrong" data-success="">ZIP</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="broker_email" id="broker_email" className="materialize-textarea" type="email" value={this.state.broker_email}
                         onChange={this.handleFormChange}  />
                        <label htmlFor="broker_email" className={this.state.broker_email?"black-text active":"black-text"}>Enter Destination Email ID</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Email id</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="broker_mobile_no" id="broker_mobile_no" className="materialize-textarea" type="text"  value={this.state.broker_mobile_no}
                          onChange={this.handleFormChange} />
                        <label htmlFor="broker_mobile_no" className={this.state.broker_mobile_no?"black-text active":"black-text"}>Enter Destination Contact Number</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Contact number</span>
                      </div>
                    </Col>
                  </Row>

                </form>
              </Col>
            </Row>
          </div>
          {/* <!-- Broker Detail Div End --> */}

      {/* <!-- Email Configuration Detail Div Start --> */}
      <div id="divemaildetail">
            <h5 className="center blue-text">Email Configuration</h5>
            <Row>
          <Col className=" rowdivPading ">
          <div className="input-field col s6 offset-s3 left">
            <span>Use Existing</span>
            <span>
            <label>
            <input name="email_use_existing" value="1" type="radio"  
            checked={this.state.email_use_existing ==="1"} onChange={this.handleFormChange}
            />
            <span>YES</span>
            </label>
            </span>
            <span>
            <label>
            <input name="email_use_existing" value="0" type="radio" 
            checked={this.state.email_use_existing ==="0"} onChange={this.handleFormChange} />
            <span>NO</span>
            </label>
            </span>

            </div>
          </Col>
          </Row>
            <Row>
              <Col xs={12} >
                <form>
                  {/* <p className="center red-text">{this.state.error}</p> */}
                  
                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="email_client_id" id="email_client_id" className="materialize-textarea" type="text" value={this.state.email_client_id} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="email_client_id" className={this.state.email_client_id?"black-text active":"black-text"}>Enter Client Id</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Email Client Id</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="email_secret" id="email_secret" className="materialize-textarea" type="text" value={this.state.email_secret} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="email_secret" className={this.state.email_secret?"black-text active":"black-text"}>Enter Email Secret Key</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Secret Key</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="email_authority" id="email_authority" className="materialize-textarea" type="text" value={this.state.email_authority} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="email_authority" className={this.state.email_authority?"black-text active":"black-text"}>Enter Email From</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Email From</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="email_to" id="email_to" className="materialize-textarea" type="text" value={this.state.email_to} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="email_to" className={this.state.email_to?"black-text active":"black-text"}>Enter Email To</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Email To</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="email_bcc" id="email_bcc" className="materialize-textarea" type="text" value={this.state.email_bcc} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="email_bcc" className={this.state.email_bcc?"black-text active":"black-text"}>Enter Email Bcc</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Email Bcc</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="email_cc" id="email_cc" className="materialize-textarea" type="text" value={this.state.email_cc} 
                         onChange={this.handleFormChange}  />
                        <label htmlFor="email_cc" className={this.state.email_cc?"black-text active":"black-text"}>Enter Email Cc</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Email Cc</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="email_scope" id="email_scope" className="materialize-textarea" type="text" value={this.state.email_scope} 
                         onChange={this.handleFormChange}  />
                        <label htmlFor="email_scope" className={this.state.email_scope?"black-text active":"black-text"}>Enter Email Scope</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Email Scope</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="email_end_point" id="email_end_point" type="text" className="" value={this.state.email_end_point} 
                        onChange={this.handleFormChange} />
                        <label htmlFor="email_end_point" className={this.state.email_end_point?"black-text active":"black-text"}>Enter Email API URL</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Email API URL</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="email_sendemail_endpoint" id="email_sendemail_endpoint" type="text" className="" value={this.state.email_sendemail_endpoint} 
                        onChange={this.handleFormChange} />
                        <label htmlFor="email_sendemail_endpoint" className={this.state.email_sendemail_endpoint?"black-text active":"black-text"}>Enter Send Email End Point</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Send Email End Point</span>
                      </div>
                    </Col>
                  </Row>

                </form>
              </Col>
            </Row>
          </div>
          {/* <!-- Email Configuration Detail Div End --> */}

          {/* <!-- WhatsApp Configuration Detail Div Start --> */}
         <div id="divwhatsappdetail">
            <h5 className="center blue-text">WhatsApp Configuration</h5>
          <Row>
          <Col className=" rowdivPading ">
          <div className="input-field col s6 offset-s3 left">
            <span>Use Existing</span>
            <span>
            <label>
            <input name="whatsapp_existing" value="1" type="radio"  
            checked={this.state.whatsapp_existing ==="1"} onChange={this.handleFormChange}
            />
            <span>YES</span>
            </label>
            </span>
            <span>
            <label>
            <input name="whatsapp_existing" value="0" type="radio" 
            checked={this.state.whatsapp_existing ==="0"} onChange={this.handleFormChange} />
            <span>NO</span>
            </label>
            </span>

            </div>
          </Col>
          </Row>
            <Row>
              <Col xs={12} >
                <form>
                  {/* <p className="center red-text">{this.state.error}</p> */}
                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="from_number" id="from_number" className="materialize-textarea" type="text" value={this.state.from_number} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="from_number" className={this.state.from_number?"black-text active":"black-text"}>Enter WhatsApp Number</label>
                        <span className="helper-text left" data-error="wrong" data-success="">WhatsApp Number</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="whatsapp_token" id="whatsapp_token" className="materialize-textarea" type="text" value={this.state.whatsapp_token} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="whatsapp_token" className={this.state.whatsapp_token?"black-text active":"black-text"}>Enter WhatsApp Token</label>
                        <span className="helper-text left" data-error="wrong" data-success="">WhatsApp Token</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="whatsapp_secret" id="whatsapp_secret" className="materialize-textarea" type="text" value={this.state.whatsapp_secret} 
                         onChange={this.handleFormChange} />
                        <label htmlFor="whatsapp_secret" className={this.state.whatsapp_secret?"black-text active":"black-text"}>Enter WhatsApp Secret Key</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Secret Key</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="whatsapp_url" id="whatsapp_url" type="text" className="" value={this.state.whatsapp_url} 
                        onChange={this.handleFormChange} />
                        <label htmlFor="whatsapp_url" className={this.state.whatsapp_url?"black-text active":"black-text"}>Enter WhatsApp URL</label>
                        <span className="helper-text left" data-error="wrong" data-success="">WhatsApp URL</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="whatsapp_namespace" id="whatsapp_namespace" type="text" className="" value={this.state.whatsapp_namespace} 
                        onChange={this.handleFormChange} />
                        <label htmlFor="whatsapp_namespace" className={this.state.whatsapp_namespace?"black-text active":"black-text"}>Enter WhatsApp Namespace</label>
                        <span className="helper-text left" data-error="wrong" data-success="">WhatsApp Namespace</span>
                      </div>
                    </Col>
                  </Row>

                  
                </form>
              </Col>
            </Row>
          </div>
          {/* <!-- Whatsapp Configuration Detail Div End --> */}

          </div>
          <div className="modal-footer">
            {/* <a href="#!" className="modal-close waves-effect waves-green btn-flat">Agree</a> */}

            <ButtonGroup className="mr-2" aria-label="First group">
              <Button id='cancelOwnerBtn' variant="outline-secondary" className="mr-4 btn modal-close "  >Cancel</Button>
              {
              this.state.editRow
              ?<Button id="updateOwnerBtn" variant="outline-primary" className="mr-2 btn" onClick = {this.updateFranciseDetailsDB}>Update</Button>
              :<Button id="addOwnerBtn" variant="outline-primary" className="mr-2 btn" onClick={this.addFranciseToDB}> Add</Button>
              }     
            </ButtonGroup>

          </div>
        </div>

        <div className="">
          <Row>
            <Col xs={12} md={12} lg={12} >
              <div className="tableheight">
                {table_render}
              </div>
            </Col>

          </Row>
          <Row>
            <Col >

              <Nav className="right">
                <Nav.Link className="red-text modal-trigger " href="" onClick={this.openWarehouseOwnerModal}>
                  Add Francise Details<Image className="red-text mr-auto" src="assets/images/plus-circle-red-m.svg"  /></Nav.Link>
              </Nav>


            </Col>
          </Row>
        </div>


      </Fragment>
    )
  }

}


